import React from 'react';
import { useStore } from 'effector-react';
import classNames from 'classnames';
import { type GeneralID, ImageType } from '@types';
import Image from '@components/Image';
import ImageContainer from '@components/ImageContainer';
import Button from '@components/Button';
import { $sceneMap } from '@stores/dataStores';
import TextLink from '@components/TextLink';
import Img from './img-placeholder.png';
import { showSceneModal } from '../../../category';

interface Props {
  title?: string;
  className?: string;
  sceneId?: GeneralID;
  warning?: boolean;
  withDeleteBtn?: boolean;
  disabledIds?: GeneralID[];
  onChange: (id: GeneralID | undefined) => void;
}

function SceneSelector({
  title = '目标场景',
  className,
  sceneId,
  warning,
  withDeleteBtn = false,
  disabledIds,
  onChange,
}: Props) {
  const map = useStore($sceneMap);
  const scene = sceneId ? map.get(sceneId) : null;

  const handleClick = async () => {
    const { idSet } = await showSceneModal({
      title: `选择${title}`,
      allowEmpty: true,
      disabledIds,
      defaultSelected: sceneId ? new Set([sceneId]) : undefined,
    });
    if (!idSet) return;
    const id = Array.from(idSet)[0];
    onChange(id);
  };

  return (
    <ImageContainer warning={warning} className={classNames('h-70', className)}>
      {scene ? (
        <Image
          className="h-50 w-50"
          size={50}
          src={scene.thumbUrl}
          type={ImageType.thumb}
        />
      ) : (
        <div className="flex h-50 w-50 items-center justify-center bg-black-#28">
          <Image className="h-16 w-16" src={Img} />
        </div>
      )}
      <div className="ml-10 flex flex-col items-start">
        {scene ? (
          <div className="w-140 truncate">{scene.name}</div>
        ) : (
          <div className="w-140 text-black-gray">{`还未设置${title}`}</div>
        )}
        <div className="mt-5 flex items-center">
          <Button size="sm" onClick={handleClick}>
            选择场景
          </Button>
          {withDeleteBtn && !!sceneId && (
            <TextLink
              className="ml-10"
              onClick={() => {
                onChange(undefined);
              }}
            >
              删除
            </TextLink>
          )}
        </div>
      </div>
    </ImageContainer>
  );
}

export default SceneSelector;
